import { render, staticRenderFns } from "./CampaignsTab.vue?vue&type=template&id=c7a6ec4a&scoped=true"
import script from "./CampaignsTab.vue?vue&type=script&lang=ts"
export * from "./CampaignsTab.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsTab.vue?vue&type=style&index=0&id=c7a6ec4a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a6ec4a",
  null
  
)

export default component.exports